import { createAction, props } from '@ngrx/store';
import { News } from '../../models/news.model';


export const loadNews = createAction(
  '[News] Load News',
  props<{ adminId:any,isAdmin?: any; page?: any; isPopular?: any; category?: any ; hashtag?: any ; pageSize?: any }>()
);
export const loadNewsSuccess = createAction(
  '[News] Load News Success',
  props<{ news: News[] }>()
);
export const loadNewsFailure = createAction(
  '[News] Load News Failure',
  props<{ error: any }>()
);
